import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import { ReviewsSlider, ReviewsType } from "components/shared/sliders/ReviewsSlider";
import styles from "./SectionReviews.module.scss";

export type SectionReviewsProps = {
  heading: string;
  subheading: string;
  reviews: ReviewsType;
};

export const SectionReviews = ({ heading, subheading, reviews }: SectionReviewsProps) => (
  <section className={styles.section}>
    <Container>
      <Heading
        title={heading}
        subheading={subheading}
        className={styles.heading}
        image="/img/icons/60/trophy.png"
      />
      <ReviewsSlider reviews={reviews} />
    </Container>
  </section>
);

export default SectionReviews;
